import * as R from 'ramda';

export default function ArchivedReportTypeController(
  $q,
  $rootScope,
  $scope,
  ssDialogService,
  loaderService,
  reportsSharedModelService,
  bulkDeleteArchivedReportInstancesDialog,
) {
  const vm = this;

  vm.isExpanded = false;

  vm.hasData = false;

  vm.filter = {
    reportOwner: "-1"
  };

  vm.handleExpandReportType = _handleExpandReportType;
  vm.handleBulkDelete = _handleBulkDelete;

  _activate();
  
  _initEventListeners();

  /** ********************************************
   * Event Handlers
   */

  function _activate() {
  }

  function _initEventListeners() {
    $scope.$on(`reports.archivedReports.reportType.archivedReportInstanceDeleted`, (event, opt) => { // eslint-disable-line max-len
      if (vm.reportType.uniqueId === opt.reportTypeId) {
        _handleRemoveReportInstance(opt.reportInstance);
      }
    });

    $scope.$on(`reports.archivedReports.reportType.archivedReportInstancesDeleted`, (event, opt) => { // eslint-disable-line max-len
      if (vm.reportType.uniqueId === opt.reportTypeId) {
        _handleReportInstancesDeleted(opt.numberOfInstancesDeleted);    
      }
    });

    $scope.$on(`reports.archivedReports.updateReportInstancesReportOwner`, (event, opt) => { 
      vm.filter.reportOwner = opt.reportOwner;
      _filterByReportOwner();
    });
  }

  function _handleExpandReportType() {
    if (vm.isExpanded) {
      vm.isExpanded = false;
      return;
    }

    loaderService.showViewLoader = true;
    _loadArchivedReportInstances().then(() => {
      loaderService.showViewLoader = false;
      vm.isExpanded = true;
    });
  }

  function _handleBulkDelete($event) {
    if ((vm.reportType.allReportInstances === null) || (vm.reportType.allReportInstances === undefined)) {
      loaderService.showViewLoader = true;
      _loadArchivedReportInstances().then(() => {
          loaderService.showViewLoader = false;
          _filterByReportOwner();
          showBulkDeleteReportInstancesDialog($event);
        });
    } else {
      showBulkDeleteReportInstancesDialog($event);
    }
  }
 
  function showBulkDeleteReportInstancesDialog($event) {
     ssDialogService.dialogs.reports.bulkDeleteArchivedReportInstancesDialog = ssDialogService.alert(
      bulkDeleteArchivedReportInstancesDialog.getOptions($event, {
        reportType: vm.reportType,
        reportInstances: vm.reportType.filteredReportInstances,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.reports.bulkDeleteArchivedReportInstancesDialog);
  }


  /** ********************************************
   * Private Functions
   */

  function _loadArchivedReportInstances() {
    vm.hasData = false;
    return reportsSharedModelService.getArchivedReportInstances(vm.reportType.uniqueId, true)
      .then((reportInstances) => {
        vm.reportType.allReportInstances = [...reportInstances];
        vm.hasData = (vm.reportType.allReportInstances.length > 0); 
        _filterByReportOwner();
      });
  }
  
  function _filterByReportOwner() {
    let _filteredReportInstances = [];

    if ((vm.reportType.allReportInstances === null) || (vm.reportType.allReportInstances === undefined) || (vm.reportType.allReportInstances.length === 0)) {
      _filteredReportInstances = vm.reportType.allReportInstances;
    } else {
      if (vm.filter.reportOwner !== "-1") {
        const _fris = [];
        
        R.forEach((reportInstance) => {          
          let _found = false;
              
          if (reportInstance.createdBy === vm.filter.reportOwner ) {
            _found = true;
          };

          if (_found) {
            _fris.push(reportInstance);

            if (reportInstance.createdBy === vm.filter.reportOwner) {
            }
          }
        }, vm.reportType.allReportInstances);

        _filteredReportInstances = _fris;
      } else {
        _filteredReportInstances = vm.reportType.allReportInstances;
      }
    }
    
    vm.reportType.filteredReportInstances = _filteredReportInstances;
    
    if ((vm.reportType.filteredReportInstances !== null) && (vm.reportType.filteredReportInstances !== undefined)) {
      vm.reportType.numberOfInstances = vm.reportType.filteredReportInstances.length;
      vm.reportType.lastGeneratedDate = _getMaxDate(vm.reportType.filteredReportInstances);
    } 
  }

  function _handleRemoveReportInstance(reportInstance) {
    if (!reportInstance) {
      return;
    }

    if (vm.reportType.allReportInstances.length <= 1) {
      // This reportType just lost its last reportInstance, so it should be removed
      vm.reportType.allReportInstances = [];
      $rootScope.$broadcast('reports.archivedReports.reportTypeEmpty', vm.reportType);
      vm.isExpanded = false;
      vm.hasData = false;
      return;
    }
    
    _remove(vm.reportType.allReportInstances);
    _remove(vm.reportType.filteredReportInstances);

    function _remove(collection) {
      const pos = collection.findIndex(item => item.reportInstanceId === reportInstance.reportInstanceId);
      if (pos === -1) return; // Can't find the item
      collection.splice(pos, 1);
    }

    // Update summary info
    _handleReportInstancesDeleted(1);
    vm.reportType.lastGeneratedDate = _getMaxDate(vm.reportType.filteredReportInstances);
  }

  function _getMaxDate(reportInstances) {
    let maxDate = reportInstances[0].createDate;
    let maxDateObj = new Date(reportInstances[0].createDate);
    reportInstances.forEach((instance) => {
      if (new Date(instance.createDate) > maxDateObj) {
        maxDate = instance.createDate;
        maxDateObj = new Date(instance.createDate);
      }
    });
    return maxDate;
  }

  function _handleReportInstancesDeleted(numberOfInstancesDeleted) {
    vm.reportType.numberOfInstances = vm.reportType.numberOfInstances - numberOfInstancesDeleted;    
    vm.reportType.numberOfDeleteableInstances = vm.reportType.numberOfDeleteableInstances - numberOfInstancesDeleted;   
    vm.reportType.totalNumberOfInstances = vm.reportType.totalNumberOfInstances - numberOfInstancesDeleted;    
    vm.reportType.totalNumberOfDeleteableInstances = vm.reportType.totalNumberOfDeleteableInstances - numberOfInstancesDeleted; 
    
    if (vm.reportType.totalNumberOfInstances > 0) {
      R.forEach((reportOwner) => {          
        if (reportOwner.ownerName === vm.userName ) {
          reportOwner.numberOfInstances = reportOwner.numberOfInstances - numberOfInstancesDeleted;    
          reportOwner.numberOfDeleteableInstances = reportOwner.numberOfDeleteableInstances - numberOfInstancesDeleted; 
        };
      }, vm.reportType.reportOwners);

      _loadArchivedReportInstances();
    } else {
      // This reportType just lost its last Report Instance, so it should be removed
      vm.reportType.allReportInstances = [];
      $rootScope.$broadcast('reports.archivedReports.reportTypeEmpty', vm.reportType);
    }
  }
}

ArchivedReportTypeController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'ssDialogService',
  'loaderService',
  'reportsSharedModelService',
  'bulkDeleteArchivedReportInstancesDialog',
];
